import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const GROUP_DELETE_RESOURCE = "group" as const;
export const GROUP_DELETE_API_PATH = `/v1/${GROUP_DELETE_RESOURCE}/{uuid}` as const;

export type GroupDeleteResponse =
  paths[typeof GROUP_DELETE_API_PATH]["delete"]["responses"][200]["content"]["application/json"];

export const useGroupDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<GroupDeleteResponse, Error, { uuid: string; force?: boolean }>({
    mutationFn: async ({ uuid, force }) => {
      const response = await alphartisApiAxios.delete<GroupDeleteResponse>(`/v1/${GROUP_DELETE_RESOURCE}/${uuid}`, {
        params: { force },
      });
      return response.data;
    },
    onSuccess: async (_data, { uuid, force }) => {
      if (!force) {
        await queryClient.invalidateQueries({ queryKey: [GROUP_DELETE_RESOURCE] });
        return;
      }

      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [GROUP_DELETE_RESOURCE],
          predicate: (query) => query.queryKey[1] !== uuid,
        }),
        queryClient.invalidateQueries({ queryKey: [GROUP_DELETE_RESOURCE, uuid], refetchType: "none" }),
      ]);
    },
  });
};
